export default __webpack_public_path__ + "static/media/zawody2.cbb6ae03.jpg";